import { render, staticRenderFns } from "./AdminChangelog.vue?vue&type=template&id=648c7efe&scoped=true&lang=pug&"
import script from "./AdminChangelog.vue?vue&type=script&lang=js&"
export * from "./AdminChangelog.vue?vue&type=script&lang=js&"
import style0 from "./AdminChangelog.vue?vue&type=style&index=0&id=648c7efe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c7efe",
  null
  
)

export default component.exports